<template>
  <v-card
    class="dash-card rounded-lg"
    flat
    outlined
    color="white"
    style="min-height: 270; height: 97%; width: 100%"
  >
    <v-card-title
      class="d-flex justify-center pt-4 pb-0 fontDash-title text-body-1"
      :class="{ 'fontDash-title': !mdAndUp }"
      style="font-family: 'Archivo', sans-serif !important"
    >
      {{ title }}
    </v-card-title>
    <v-card-text
      class="d-flex flex-row justify-center align-center"
      style="min-height: 150px; font-family: 'Archivo', sans-serif !important"
    >
      <v-progress-circular
        :size="70"
        :color="$config.dados.corinputs"
        v-if="loading"
        indeterminate
      ></v-progress-circular>
      <v-row justify="center" v-else>
        <template v-if="mdAndUp">
          <template v-if="information">
            <v-col cols="4" sm="4" class="d-flex flex-column align-center">
              <span
                v-for="(infoTitle, index) in information.titles"
                :key="index"
                class="text-body-1"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ infoTitle }}
              </span>
            </v-col>
            <v-col cols="4" sm="2" class="d-flex flex-column align-center">
              <span
                v-for="(infoValues, index) in information.values"
                :key="index"
                class="text-body-1"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ infoValues }}
              </span>
            </v-col>
          </template>
          <template v-if="percent">
            <v-col
              cols="6"
              sm="6"
              md="6"
              class="d-flex flex-column align-center justify-space-between"
            >
              <span>{{ percent.text }}</span>
              <h1
                v-if="percent.value.includes('R$')"
                :class="percent.class"
                class="text-h4 mb-n2"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ percent.value }}
              </h1>
              <v-progress-circular
                v-else
                :value="percent.value"
                size="80"
                width="8"
                class="mb-2 mt-n3"
                :class="isNegative ? 'negative-percent' : 'positive-percent'"
                >{{ percent.value }}</v-progress-circular
              >
            </v-col>
          </template>
          <template v-if="percentcheck">
            <v-col
              cols="6"
              sm="6"
              md="6"
              class="d-flex flex-column align-center justify-space-between"
            >
              <span>{{ percentcheck.text }}</span>
              <h1
                v-if="percentcheck.value.includes('R$')"
                :class="percent.class"
                class="mb-6 text-h3"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ percentcheck.value }}
              </h1>
              <v-progress-circular
                v-else
                :value="percentcheck.value"
                size="80"
                width="8"
                class="mb-2"
                :class="isNegative ? 'negative-percent' : 'positive-percent'"
                >{{ percentcheck.value }}</v-progress-circular
              >
            </v-col>
          </template>
        </template>
        <template v-else>
          <template v-if="information">
            <v-col cols="6" class="d-flex flex-column align-center">
              <span
                v-for="(infoTitle, index) in information.titles"
                :key="index"
                class="text-body-1"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ infoTitle }}
              </span>
            </v-col>
            <v-col cols="6" class="d-flex flex-column align-center">
              <span
                v-for="(infoValues, index) in information.values"
                :key="index"
                class="text-body-1"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ infoValues }}
              </span>
            </v-col>
          </template>
          <v-divider v-if="information"></v-divider>
          <template v-if="percent">
            <v-col
              cols="6"
              sm="6"
              md="6"
              class="d-flex flex-column align-center justify-space-between"
            >
              <span>{{ percent.text }}</span>
              <h1
                v-if="percent.value.includes('R$')"
                :class="percent.class"
                class="text-h4"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ percent.value }}
              </h1>
              <v-progress-circular
                v-else
                :value="percent.value"
                size="88"
                width="10"
                class="mb-2"
                :class="isNegative ? 'negative-percent' : 'positive-percent'"
                >{{ percent.value }}</v-progress-circular
              >
            </v-col>
          </template>
          <template v-if="percentcheck">
            <v-col
              cols="6"
              sm="6"
              md="6"
              class="d-flex flex-column align-center justify-space-between"
            >
              <span>{{ percentcheck.text }}</span>
              <h1
                v-if="percentcheck.value.includes('R$')"
                :class="percent.class"
                class="mb-6 text-h3"
                style="font-family: 'Archivo', sans-serif !important"
              >
                {{ percentcheck.value }}
              </h1>
              <v-progress-circular
                v-else
                :value="percentcheck.value"
                size="88"
                width="10"
                class="mb-2"
                :class="isNegative ? 'negative-percent' : 'positive-percent'"
                >{{ percentcheck.value }}</v-progress-circular
              >
            </v-col>
          </template>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "DashCardCheckin",
  mixins: [displayHelpers],
  props: {
    refreshInfo: {
      type: String,
      required: false,
      default: "",
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "base",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    information: {
      type: Object,
      required: false,
      default: () => {},
    },
    percent: {
      required: false,
    },
    percentcheck: {
      required: false,
    },
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    table: {
      type: Boolean,
      required: false,
      default: false,
    },
    headers: {
      type: Array,
      required: false,
      default: () => [],
    },
    list: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    applyFillHeight() {
      return this.fillHeight ? "height: 100%" : "";
    },
    hasPercentContent() {
      return (
        Object.keys(this.percent) >= 0 && Object.keys(this.percentcheck) >= 0
      );
    },
    isNegative() {
      return (
        this.percent.value.includes("-") ||
        (parseFloat(this.percent.value) < 0 &&
          this.percentcheck.value.includes("-")) ||
        parseFloat(this.percentcheck.value) < 0
      );
    },
  },
  methods: {
    refreshDashCard() {
      this.$dashboard.refreshDashInfo(this.refreshInfo);
    },
  },
};
</script>

<style scoped>
.dash-card {
  border-radius: 15px !important;
  /* box-shadow: inset -26px 26px 52px #c3c2c2, inset 26px -26px 52px #e1e0e0 !important; */
}
.positive-percent {
  color: #572c88;
  font-size: 0.875rem;
}

.negative-percent {
  color: #d70200;
  font-size: 0.875rem;
}
.refresh-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>
